import { render } from "./ErrorBoundary.vue?vue&type=template&id=cf43e806"
import script from "./ErrorBoundary.vue?vue&type=script&lang=js"
export * from "./ErrorBoundary.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__